<!-- This file is part of VBS.
    Copyright (C) 2022  Dylan Loya

    This program is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>. -->
<template>
  <div v-if="Object.keys(books).length > 0">
    <GridOfCard :books="books" :inSouhait="true" />
  </div>
  <div v-else>
    <v-container class="d-flex flex-column justify-center align-center">
      <v-icon class="ontertiary--text pt-16" x-large>
        sentiment_very_dissatisfied
      </v-icon>
      <h1 class="ontertiary--text Heading 1 pt-16">
        {{ $t("SouhaitsView.no_books") }}
      </h1>
      <h2 class="ontertiary--text pt-12">
        {{ $t("SouhaitsView.search_to_add") }}
      </h2>
    </v-container>
  </div>
</template>
<script>
import GridOfCard from "../components/GridOfCard";
export default {
  name: "SouhaitsView",
  components: { GridOfCard },
  data: () => {
    return {
      books: {},
    };
  },
  mounted() {
    this.getBooks();
  },
  methods: {
    async getBooks() {
      let books = localStorage.getItem("vbs-souhaits");
      this.books = JSON.parse(books);
      console.log(this.books);
    },
  },
};
</script>
<style scoped>
.v-icon {
  font-size: 200px !important;
}
</style>
